import { NgFor } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomValidatorsService } from '@shared/validators/custom-validators.service';

@Component({
  selector: 'app-modal-email-aerovales',
  standalone: true,
  imports: [ReactiveFormsModule, NgFor],
  templateUrl: './modal-email-aerovales.component.html',
  styleUrls: ['./modal-email-aerovales.component.scss'],
})
export class ModalEmailAerovalesComponent {
  @Input() titulo: string = '';
  emails: string[] = [];
  constructor(private activeModal: NgbActiveModal) {}
  
  emailFormControl = new FormControl<string | null>(null, [
    Validators.required,
    CustomValidatorsService.emailValidator,
  ]);

  chequearMail(): boolean {
    const emailValue = this.emailFormControl.value?.trim().toLowerCase();
    return emailValue ? this.emails.includes(emailValue) : false;
  }

  agregarMail(): void {
    const emailValue = this.emailFormControl.value?.trim().toLowerCase();

    if (emailValue && this.emailFormControl.valid && !this.chequearMail()) {
      this.emails.push(emailValue);
      this.emailFormControl.reset();
    }
  }


  eliminarMail(index: number): void {
    if (index >= 0 && index < this.emails.length) {
      this.emails.splice(index, 1);
    }
  }

  guardar() {
    this.activeModal.close(this.emails);
  }
  
  cerrar() {
    this.activeModal.dismiss();
  }

  get isEmailInvalid(): boolean {
    return this.emailFormControl.invalid && (this.emailFormControl.dirty || this.emailFormControl.touched);
  }
}
